import { useMutation } from "@apollo/client/react";
import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import SAVE_REQUERIMIENTOS_ACTUALES_VISITA_CD, { adaptRequerimientosActualesCDInput } from "../../../../../../data/graphQL/mutations/Visitas/saveRequerimientosActualesCD";
import SAVE_TRATAMIENTO_VISITA_CD, { adaptTratamientoCDInput } from "../../../../../../data/graphQL/mutations/Visitas/saveTratamientoCD";
import { SAVE_VISITA_CP_REQUERIMIENTOS_ACTUALES, adaptVisitaCPRequerimientosActualesInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaCP";
import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

// Config pura, fuera del componente: mapea cada variante a lo que la diferencia
// (mutation, adapter, stepId/stepName y el name del input de observación).
const STEP_CONFIG = {
    Tratamiento: {
        mutation: SAVE_TRATAMIENTO_VISITA_CD,
        adapter: adaptTratamientoCDInput,
        stepId: "tratamiento",
        stepName: "Tratamiento",
        inputName: "obsTratamiento"
    },
    RequerimientoActual: {
        mutation: SAVE_REQUERIMIENTOS_ACTUALES_VISITA_CD,
        adapter: adaptRequerimientosActualesCDInput,
        stepId: "requerimientoActual",
        stepName: "Requerimiento Actual",
        inputName: "obsRequerimientoActual"
    },
    RequerimientoActualCP: {
        mutation: SAVE_VISITA_CP_REQUERIMIENTOS_ACTUALES,
        adapter: adaptVisitaCPRequerimientosActualesInput,
        stepId: "requerimientoActual",
        stepName: "Requerimiento Actual",
        inputName: "observacionRequerimientosActuales"
    }
};

// Pura, fuera del componente: arma la definición base de inputs a partir del name que corresponda.
const buildInputs = (inputName) => [
    {
        name: inputName,
        displayName: "Observación",
        type: "extended_string",
        required: true
    }];


export const ObservacionVisitaStep = ({ variant, readOnly, onSaveRef, onExposeFormatted }) => {
    const config = STEP_CONFIG[variant];

    const [formData, setFormData] = useState({});
    const { visita, setVisita } = useVisita();

    const [save] = useMutation(config.mutation);

    const inputs = useMemo(() => buildInputs(config.inputName), [config.inputName]);

    const formattedInputs = useMemo(() => {
        return inputs.map((input) => {
            const newInput = { ...input };

            if (readOnly) newInput.disabled = true;

            return newInput;
        });

    }, [inputs, readOnly]);

    const handleChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    useStepSave(onSaveRef, async (validate) => {
        if (validate) validateStepFields({ formattedInputs, formData });

        const { data } = await save({ variables: { input: config.adapter(formData) } });

        setVisita((prev) => ({
            ...prev,
            ...formData
        }));
    });

    useEffect(() => {
        setFormData(visita);
    }, [visita]);

    useEffect(() => {
        onExposeFormatted?.({
            stepId: config.stepId,
            stepName: config.stepName,
            formattedInputs
        });
    }, [onExposeFormatted, formattedInputs, config.stepId, config.stepName]);

    return (
        <CardBox>
            <Grid container spacing={2}>
                {formattedInputs.map((input) =>
                    <Grid size={{ xs: 12 }} key={input.name}>
                        <RenderInputByTypeMobile
                            key={input.name}
                            input={input}
                            value={formData[input.name]}
                            handleChange={handleChange} />

                    </Grid>
                )}
            </Grid>
        </CardBox>);

};